import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import locale from "../../../utils/locale";
const style = {
  background: '#0A5DB8',
};
const CallMe = ({ show, onCallMe, disable }) => {
  return (
    <div>
      {show ? (
        <div>
          <Button
            className="br-25"
            variant="raised"
            color="primary"
            onClick={onCallMe}
            disabled={disable}
            fullWidth
            style={style}
          >
            {locale("callMe")}
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

CallMe.propTypes = {
  show: PropTypes.bool,
  onCallMe: PropTypes.func,
  disable: PropTypes.bool
};

export default CallMe;



// WEBPACK FOOTER //
// ./src/components/help/CallMe/index.js